export { default } from './SecondModelConfiguration';
